import script from "./UnassignedTable.vue?vue&type=script&setup=true&lang=js"
export * from "./UnassignedTable.vue?vue&type=script&setup=true&lang=js"

import "./UnassignedTable.vue?vue&type=style&index=0&id=bf36eecc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf36eecc"]])

export default __exports__